import { render } from "./AffiliationsDetailsPage.vue?vue&type=template&id=380c4cea&scoped=true&ts=true"
import script from "./AffiliationsDetailsPage.vue?vue&type=script&lang=ts"
export * from "./AffiliationsDetailsPage.vue?vue&type=script&lang=ts"

import "./AffiliationsDetailsPage.vue?vue&type=style&index=0&id=380c4cea&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-380c4cea"]])

export default __exports__